import { createFileRoute } from "@tanstack/react-router";
import WhatIsNearshoring from "@/pages/WhatIsNearshoring";

export const Route = createFileRoute("/what-is-nearshoring")({
  component: WhatIsNearshoring,
});
